<template>
  <div>
    <div class="b-banner-con">
      <v-header></v-header>
      <v-nav></v-nav>
    </div>
    <v-breadcrumb></v-breadcrumb>
    <!-- 主题内容 -->
    <div class="b-center-container">
      <!-- 富文本 -->
      <div class="b-container">
        <div class="b-center-main" style="padding: 60px;">
          <div class="title">
            关于我们
          </div>
          <div class="contentLeft">
            <ul class="leftNavigation">

              <li class="clickable"><a href="/about?id=xmjj"><i class="fa fa-caret-right leftNavIcon" aria-hidden="true"></i>设施简介</a></li>

              <li class="clickable "><a href="/about8"><i class="fa fa-caret-right leftNavIcon" aria-hidden="true"></i>研究院简介</a></li>

              <li class="clickable"><a href="/about2"><i class="fa fa-caret-right leftNavIcon" aria-hidden="true"></i>领导团队</a></li>

              <li class="clickable"><a href="about6?id=zhyxjd"><i class="fa fa-caret-right leftNavIcon" aria-hidden="true"></i>科研设施</a></li>
              <li class="clickable"><a href="/about3"><i class="fa fa-caret-right leftNavIcon" aria-hidden="true"></i>技术系统</a></li>

              <li class="clickable active"><a href="/about5?id=yxgltx"><i class="fa fa-caret-right leftNavIcon" aria-hidden="true"></i>组织架构</a></li>
            </ul>
          </div>
          <div class="b-richtext">
            <p v-html="richText"></p>
          </div>
        </div>
      </div>
    </div>
    <v-contact></v-contact>
  </div>
</template>
<script>
  /* eslint-disable */
  import Header from "@/components/header/";
  import Nav from "@/components/nav/";
  import Copy from "@/components/copy/"
  import Breadcrumb from "@/components/breadcrumb/"
  import Footer from "@/components/footer/"
  import Contact from "@/components/contact/";
  export default {
    data () {
      return {
        richText: '',
      };
    },
    created () {
      if(this.$route.query.id == 'xmjj') {
        this.richText = '<p style="text-align: left; "><span style="margin-left: 295px; font-size: 22px; border-bottom: solid 3px #0c5cc8;">设施简介</span></p>'
          + '<br/>'
          + '<div id="left" style="float:left ; width:50%; height:100%;">'
          + '<p style="margin-bottom : 20px"><span style="margin-left: 36px; font-size: 16px;">重大科技基础设施是为探索未知世界、发现自然规律、实现技术变革提供极限研究手段的大型复杂科学研究系统，是突破科学前沿、解决经济社会发展和国家安全重大科技问题的物质技术基础。</span></p>'
          + '<p style="margin-bottom : 20px"><span style="margin-left: 36px; font-size: 16px;">“转化医学国家重大科技基础设施（上海）”项目是“十二五”国家规划的重点领域之一，以肿瘤、代谢性疾病、心脑血管疾病等三类重大疾病转化研究，药物、试剂、材料有效性验证，大型高端医疗装备关键共性技术转化应用为目标进行设计建设的规模化、集成化、系统性综合研究设施。</span></p>'
          + '<p style="margin-bottom : 20px"><span style="margin-left: 36px; font-size: 16px;">' +
          '<p>&nbsp;</p>' +
          '<ul>' +
          '<li style="list-style-type : disc; margin-bottom : 15px; margin-left: 30px; font-size: 18px;color: #0c5cc8;">项目法人：上海交通大学</li>' +
          '<li style="list-style-type : disc; margin-bottom : 15px; margin-left: 30px; font-size: 18px;color: #0c5cc8;">主管部门：教育部、上海市</li>' +
          '<li style="list-style-type : disc; margin-bottom : 15px; margin-left: 30px; font-size: 18px;color: #0c5cc8;">建设单位：上海交通大学、附属瑞金医院</li>' +
          '<li style="list-style-type : disc; margin-bottom : 15px; margin-left: 30px; font-size: 18px;color: #0c5cc8;">项目总建筑面积：11.4 万平方米</li></ul></span></p>'
          + '<p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p>'
          + '<p style="margin-bottom : 20px; text-align: center"><img src="https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/jj3.png" alt="" width="604" height="453"></p>'
          + '</div>'
          + '<div id="right" style="float: left; width: 50%; height: 100%;">'
          + '<p style="margin-bottom : 20px; text-align: center"><img src="https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/jj1.png" alt="" width="394" height="253"></p>'
          + '<p style="margin-bottom : 20px; text-align: center"><img src="https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/jj2.png" alt="" width="404" height="533"></p>'
          + '<p style="margin-top: 76px; margin-left: 56px; margin-bottom : 20px;margin-right: 53px; "><span style="margin-left: 36px; font-size: 16px;">按照综合和专业相结合的原则，囯家分别在上海(上海交通大学)、四川成都（华西医院）、北京（协和医院、解放军总医院）、陕西西安（空军军医大学）布局建设转化医学研究设施，形成覆盖全国主要区域的转化医学研究支撑网络。其中，上海设施按照“先行先试”原则于 2013 年立项，\n' +
          '2016 年启动全面建设，2019 年率先进入试运行。</span></p>'

          + '</div>'
          + '<p>&nbsp;</p><p>&nbsp;</p>'
      }else if(this.$route.query.id == 'jsnr'){
        this.richText = '<p style="text-align: left; "><span style="margin-left: 295px; font-size: 22px; border-bottom: solid 3px #0c5cc8;">建设内容</span></p>'
          + '<p style="margin-bottom : 20px"><span style="margin-left: 86px; font-size: 16px;">针对我国重大疾病诊疗中的重大关键技术，重点在肿瘤领域（主要为白血病等造血系统肿瘤、胃肠肿瘤和儿童癌症），同时针对代谢性疾病领域（主要为内分泌代谢疾病）和心脑血管疾病领域（主要为高血压和先心病）等重大疾病，研究相关发病机理和规律，建立相关疾病预测、预防、早期诊断和个体化治疗的理论、模型和方法，解决重大疾病的发生、发展与转归中的重大科学问题。</span></p>'
          +'<p style="text-align: center"><img src="https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/jsnr1.png" style="width: 800px; margin-right: 16px;margin-bottom: 16px;" width="900px"  border="0" vspace="0" alt=""></p>'
          + '<p style="margin-bottom : 20px;text-align: center"><span style="margin-left: 36px; font-size: 26px; color: #0c5cc8; background-color: mediumblue ">&nbsp;&nbsp;&nbsp;健康促进&nbsp;&nbsp;&nbsp;</sspan></p>'
          + '<p style="margin-bottom : 20px"><span style="margin-left: 86px; font-size: 16px;">国家设施技术系统分别位于瑞金医院和闵行校区的两个基地，是“优势突出、密切联系、互补相容、功能完整”的有机整体，主要包括资源信息系统、技术支撑系统和临床转化系统三大板块，并与三大类疾病的科研转化形成“三纵三横”的总体格局。</span></p>'
          +'<p style="text-align: center"><img src="https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/jsnr2.png" style="width: 800px; margin-right: 16px;margin-bottom: 16px;" width="800px"  border="0" vspace="0" alt=""></p>'
          +'<p style="text-align: center"><img src="https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/jsnr3.png" style="width: 800px; margin-right: 16px;margin-bottom: 16px;" width="800px"  border="0" vspace="0" alt=""></p>'
      }else if(this.$route.query.id == 'yxgltx'){
        this.richText = '<p style="text-align: left; "><span style="margin-left: 295px; font-size: 22px; border-bottom: solid 3px #0c5cc8;">运行管理体系</span></p>'
          + '<br/>'
          + '<p style="text-align: center"><img src="https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/yxgltx.png" style="width: 800px; margin-right: 16px;margin-bottom: 16px;" width="800px"  border="0" vspace="0" alt=""></p>'
      }
    },
    components: {
      "v-header": Header,
      "v-nav": Nav,
      "v-copy": Copy,
      "v-breadcrumb": Breadcrumb,
      "v-footer": Footer,
      "v-contact": Contact,
    }
  };
</script>
<style lang="scss" scoped>
  @media screen and (max-width:600px) {
	.b-banner-con{
	    //padding: 22px 0;
	    background: url(../../assets/img/banner_bg.png) no-repeat!important;
	    background-size: cover!important;
	    .b-header{
	      margin-bottom: 0px;
	    }
	    height: 134px;
	    width: 1440px;
	}
  }

  @media screen and (min-width:960px) {
      @media screen and (max-width:600px) {
	.b-banner-con{
	    //padding: 22px 0;
	    background: url(../../assets/img/banner_bg.png) no-repeat!important;
	    background-size: cover!important;
	    .b-header{
	      margin-bottom: 0px;
	    }
	    height: 134px;
	    width: 1440px;
	}
  }

  @media screen and (min-width:960px) {
    .b-banner-con{
	    //padding: 22px 0;
	    background: url(../../assets/img/banner_bg.png) no-repeat!important;
	    background-size: cover!important;
	    .b-header{
	      margin-bottom: 0px;
	    }
	    height: 134px;
    }
  }
  }

  .b-richtext {
    text-align:left;
    margin-top: -50px;
    b,
    strong {
      font-weight: 700;
    }
    p {
      margin: 0 0 20px;
    }
    line-height: 32px;
  }

  ///////////////
  .title {
    width: 230px;
    margin-bottom: 0px;
    position: relative;
    padding: 10px 15px 11px;
    background: #0c5cc8;
    font-size: 22px;
    font-weight: 500;
    color:#ffffff;
    text-transform:uppercase;
  }
  .contentLeft {
    width: 230px;
    float: left;
    margin-right: 35px;
    top: 0;
    left: 0;
    background-color: #f2f7ff;
  }

  .contentRight {
    padding: 1.3rem 2rem;
    margin-left: 250px;
  }

  .leftNavigation {
    margin: 0rem 0;
  }
  .leftNavigation li {border-bottom: solid 1px #c6dbf5;border-right: solid 1px #c6dbf5;}
  .leftNavigation, .leftNavigation li ul {
    list-style: none;
    padding: 0;
  }
  .leftNavigation li a {
    font-size: 16px;
    display: block;
    padding: 10px 30px 10px 20px;
    color: #1f1f1f;
    /*border-bottom: solid 1px #1e76b8;*/
    text-overflow: ellipsis;
    overflow: hidden;
    position: relative;
    -webkit-transition: color 0.2s ease;
    transition: color 0.2s ease;
    font-weight:400;
    border-left: #c6dbf5 solid 5px;
    border-right: #c6dbf5 solid 5px;
  }
  .leftNavigation li a, .leftNavigation li a .leftNavIcon {
    line-height: 160%;
  }
  .leftNavigation li a .leftNavIcon {
    position: absolute;
    top: 0;
    left: -1px;
    /*width: 3rem;*/
    padding: 6px 0;
    text-align: center;
    font-weight:100;color: #f2f7ff;font-size: 20px;
  }
  .leftNavigation li.active a .leftNavIcon {color: #7396c3;}
  .leftNavigation li a .leftNavIcon1 {
    position: absolute;
    top: 0;
    left: 0;
    width: 4rem;
    padding: 0.8rem 0;
    text-align: center;
  }
  .leftNavigation li a:hover {
    color: #142e8f; text-decoration:none; background:#d6e7fd;
    border-left: #7396c3 solid 5px;
    border-right: #7396c3 solid 5px;
  }
  .leftNavigation li a:hover .leftNavIcon {color: #7396c3;}
  .leftNavigation li ul {
    /*display: none;*/
    margin: 0;border-top: solid 1px #c6dbf5;border-left: #c6dbf5 solid 5px;padding: 8px 0;
  }
  .leftNavigation li ul li { border-bottom: solid 0px #1e76b8;}
  .leftNavigation li ul li a {
    border: 0px; font-size:13px; color:#383838; background:url(../../assets/img/csu_ico_17.gif) no-repeat 30px 10px;padding: 5px 15px 5px 48px;border-left: 0;
  }
  .leftNavigation li ul li a:hover {
    background:url(../../assets/img/csu_ico_17.gif) no-repeat 30px 10px;color:#142e8f;text-decoration:none;border: 0;
  }
  /*#

   li ul li:last-child a {
    border-bottom: none;
  }*/
  .leftNavigation li ul li.active a {
    color: #8bebff; text-decoration:none;
  }
  .leftNavigation li.active > a {
    color: #142e8f; text-decoration:none;
    border-left: #7396c3 solid 5px;
    border-right: #7396c3 solid 5px;
  }
  .leftNavigation li.active ul {
    display: block;border-top: solid 1px #1e76b8;
  }
  .leftNavigation > li.active {
    background-color: #d6e7fd;
  }
  .leftNavigation li ul li .level4 {border-top: solid 1px #1e76b8;}
  .leftNavigation li ul li .level4 li a {
    border-bottom: solid 0px #D0E9F3; font-size:14px; color:#e2f5fa; padding-left:42px;background: transparent;border-left: #2473c0 solid 5px;
  }
  .leftNavigation li ul li .level4 li a:hover {color: #8bebff;}
  .leftNavigation li ul li .level4 li {border-bottom: solid 1px #1e76b8;}
  .leftNavigation li ul li .level4 li:last-child {border-bottom: solid 0px #D0E9F3;}

</style>



// WEBPACK FOOTER //
// src/pages/about5/index.vue